// 서비스 신청 타입 정의
export const requestTypes = [
  'approval.types.create-vd',
  'approval.types.change-spec-vd',
  'approval.types.delete-vd',
  'approval.types.reset-vd',
  'approval.types.create-share-drive',
  'approval.types.modify-drive-size',
  'approval.types.modify-drive-permission',
  'approval.types.delete-drive',
];

// 결재선 상태
export const approvalLineStates = {
  0: 'approval.state.waiting',
  1: 'approval.state.approved',
  2: 'approval.state.rejected',
};

// 네트워크 드라이브 타입
export const driveTypeEnum = {
  individual: '개인',
  share: '공유',
};
